import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Paper, Tooltip, Typography } from "@mui/material";

// «شاراتي» — always on screen during the session. Combines the badges won in
// this room (relay state, works for guests too) with the ones already in a
// registered student's account.
const MyBadgesPanel = ({ myRow, badgeCatalog, isRegistered }) => {
  const [accountBadges, setAccountBadges] = useState([]);

  useEffect(() => {
    if (!isRegistered) return;
    axios
      .get(`${process.env.REACT_APP_API_URL}/whiteboard/my-badges`)
      .then((response) => setAccountBadges(response?.data?.data ?? []))
      .catch(() => setAccountBadges([]));
  }, [isRegistered]);

  const seen = new Set();
  const badges = [];

  // this session first — they are the fresh ones
  (myRow?.badges || []).forEach((id) => {
    const badge = badgeCatalog?.[id] || badgeCatalog?.[String(id)];
    if (!badge || seen.has(String(id))) return;
    seen.add(String(id));
    badges.push({ ...badge, fresh: true });
  });

  accountBadges.forEach((award) => {
    const id = String(award.badge?.id ?? award.badge_id);
    if (seen.has(id)) return;
    seen.add(id);
    badges.push({
      id,
      name: award.badge?.name || "",
      icon: award.badge?.icon || "🏅",
      color: award.badge?.color || "#f6bf26",
      description: award.badge?.description,
      fresh: false,
    });
  });

  return (
    <Paper elevation={1} sx={{ borderRadius: "16px", padding: "16px", marginBottom: "16px" }}>
      <Typography variant="subtitle1" fontWeight={700} mb={1}>
        🏅 شاراتي {badges.length > 0 && `(${badges.length})`}
      </Typography>

      {badges.length === 0 ? (
        <Typography fontSize="0.82rem" color="text.secondary">
          لم تحصل على شارات بعد — شارك وأجب بشكل صحيح لتكسب أول شارة.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          {badges.map((badge) => (
            <Tooltip
              key={badge.id}
              title={`${badge.name}${badge.fresh ? " — من هذه الحصة" : ""}${badge.description ? ` · ${badge.description}` : ""}`}
            >
              <Box sx={{ width: 62, textAlign: "center" }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    margin: "0 auto 4px",
                    borderRadius: "50%",
                    background: badge.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.4rem",
                    boxShadow: badge.fresh
                      ? "0 0 0 3px #fff, 0 0 0 5px #f6bf26"
                      : "0 3px 8px rgba(0,0,0,0.18)",
                  }}
                >
                  {badge.icon}
                </Box>
                <Typography fontSize="0.62rem" fontWeight={700} lineHeight={1.25} noWrap>
                  {badge.name}
                </Typography>
              </Box>
            </Tooltip>
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default MyBadgesPanel;
